import { Card } from 'shared/components/ui/Card';
import { Input } from 'shared/components/ui/Input';
import { Button } from 'shared/components/ui/Button';

export interface NewRachaForm {
  sport: string;
  location: string;
  when: string;
  level: string;
  spots: number;
  notes: string;
}

interface CreateRachaCardProps {
  form: NewRachaForm;
  onChange: (patch: Partial<NewRachaForm>) => void;
  onPublish: () => void;
  onCancel: () => void;
}

const SPORTS = ['Beach Tennis', 'Futevôlei', 'Pickleball', 'Vôlei de Praia'];
const LEVELS = ['Iniciante', 'Intermediário', 'Avançado'];

export function CreateRachaCard({ form, onChange, onPublish, onCancel }: CreateRachaCardProps) {
  return (
    <Card>
      <h3 className="font-heading font-semibold text-ink">Criar racha</h3>
      <p className="text-sm text-ink-secondary">
        Publica no mural da arena. Outros jogadores podem confirmar presença.
      </p>

      <div className="mt-3 grid gap-3 sm:grid-cols-2">
        <label className="flex flex-col gap-1 text-sm text-ink">
          Esporte
          <select
            value={form.sport}
            onChange={(event) => onChange({ sport: event.target.value })}
            className="rounded-lg border border-border px-3 py-2 text-sm"
          >
            {SPORTS.map((sport) => (
              <option key={sport} value={sport}>
                {sport}
              </option>
            ))}
          </select>
        </label>

        <label className="flex flex-col gap-1 text-sm text-ink">
          Nível recomendado
          <select
            value={form.level}
            onChange={(event) => onChange({ level: event.target.value })}
            className="rounded-lg border border-border px-3 py-2 text-sm"
          >
            {LEVELS.map((level) => (
              <option key={level} value={level}>
                {level}
              </option>
            ))}
          </select>
        </label>

        <Input
          label="Quadra ou local sugerido"
          name="location"
          placeholder="Ex.: Areia 3"
          value={form.location}
          onChange={(event) => onChange({ location: event.target.value })}
        />

        <Input
          label="Data e horário"
          name="when"
          placeholder="Ex.: Hoje 19h"
          value={form.when}
          onChange={(event) => onChange({ when: event.target.value })}
        />

        <Input
          label="Quantidade de vagas"
          name="spots"
          type="number"
          min={1}
          value={form.spots}
          onChange={(event) => onChange({ spots: Number(event.target.value) })}
        />
      </div>

      <label className="mt-3 flex flex-col gap-1 text-sm text-ink">
        Observações
        <textarea
          value={form.notes}
          onChange={(event) => onChange({ notes: event.target.value })}
          placeholder="Ex.: Nível B/B+, chama quem quiser jogar."
          rows={2}
          className="rounded-lg border border-border bg-background px-3 py-2 text-sm text-ink outline-none focus:border-primary"
        />
      </label>

      <div className="mt-3 flex gap-2">
        <Button variant="ghost" className="flex-1" onClick={onCancel}>
          Cancelar
        </Button>
        <Button
          className="flex-1"
          onClick={onPublish}
          disabled={!form.location.trim() || !form.when.trim()}
        >
          Publicar racha
        </Button>
      </div>
    </Card>
  );
}
